/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const directRoutes = {
  name: RouteName.LiveRoot,
  path: "live",
  component: () => import("@follaw-fr/views/side_menu_views/EnDirect.vue"),
  redirect: () => ({ name: RouteName.LiveEliasse }),
  children: [
    {
      name: RouteName.LiveEliasse,
      path: "eliasse",
      component: () => import("@follaw-fr/views/en-direct/EliasseView.vue"),
    },
    {
      name: RouteName.LiveEnSeance,
      path: "en-seance",
      component: () =>
        import("@follaw-fr/views/en-direct/SenateEnSeanceView.vue"),
    },
  ],
};
